import React, { useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import SearchBlockWithTitle from '../../procedures/Q8/Layouts/SearchBlockWithTitle'
import SearchProductWithVariety from '../../knisot/Create/Components/SearchProductWithVariety'
import SearchSize from '../../knisot/Create/Components/SearchSize'
import SearchGrower from '../../knisot/Create/Components/SearchGrower'
import SearchPackage from '../../knisot/Create/Components/SearchPackage'
import CircleNumericInput from '../../../../../generic/inputs/CircleNumericInput'
import ControlButton from '../../../../../generic/buttons/ControlButton'
import { IProductsWithVarietyItem } from '../../../../../modules/API/Defaults/models/compliteProducts'
import { ISizeItem } from '../../../../../modules/API/Products/models/size'
import { IGrowerItem } from '../../../../../modules/API/Defaults/models/growers'
import { IPackagesItem } from '../../../../../modules/API/Defaults/models/packages'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import { Product } from '../../../../../modules/API/Products/products'
import { RootState } from '../../../../../../store/reducers/rootReducer'

type Props = {
  productList: IProductsWithVarietyItem[]
  growerList: IGrowerItem[]
  onClose: () => void
  onAdd: (product: {
    ProductID: number
    VarietyID: number
    SizeID: string
    GrowerID: number
    GrowerName: string
    Qty: number
    ProductDesc: string
    VarietyDesc: string
    PackageID: number
  }) => void
  defaultProduct?: {
    ProductID: number
    VarietyID: number
    SizeID: string
    PackageID: number
  }
}

const AddProductModal = ({
  productList,
  growerList,
  onClose,
  onAdd,
  defaultProduct
}: Props) => {
  const [selectedProductID, setSelectedProductID] = useState<number>(defaultProduct?.ProductID || 0)
  const [selectedVarietyID, setSelectedVarietyID] = useState<number>(defaultProduct?.VarietyID || 0)
  const [selectedSize, setSelectedSize] = useState<ISizeItem | null>(null)
  const [selectedGrowerID, setSelectedGrowerID] = useState<number>(0)
  const [selectedPackageID, setSelectedPackageID] = useState<number>(defaultProduct?.PackageID || 0)
  const [qty, setQty] = useState<number>(0)

  // Get package list from Redux store
  const packageList: IPackagesItem[] = useSelector((state: RootState) => state.defaults.packageList) || []

  // Fetch sizes for selected product
  const {
    data: sizeList
  } = useDataFetcher<ISizeItem[]>(
    Product.getSizesByProduct,
    selectedProductID.toString()
  )

  const isFormValid = () => {
    return selectedProductID && selectedGrowerID && qty
  }

  const handleAdd = () => {
    if (!isFormValid()) return

    const selectedGrower = growerList.find(g => g.GrowerID === selectedGrowerID)
    if (!selectedGrower) return

    const selectedProduct = productList.find(p => 
      p.ProductID === selectedProductID && p.VarietyID === selectedVarietyID
    )
    if (!selectedProduct) return

    onAdd({
      ProductID: selectedProductID,
      VarietyID: selectedVarietyID,
      SizeID: selectedSize?.Description || '',
      GrowerID: selectedGrowerID,
      GrowerName: selectedGrower.GrowerName,
      Qty: qty,
      ProductDesc: selectedProduct.ProductDesc,
      VarietyDesc: selectedProduct.VarietyDesc,
      PackageID: selectedPackageID
    })
  }

  return (
    <ModalWrapper>
      <BodyWrapper>
        <SearchBlockWithTitle title={['פריט', 'כמות']}>
          <CircleNumericInput
            value={qty}
            changeFunc={setQty}
          />
          <SearchProductWithVariety
            list={productList}
            defaultProductID={selectedProductID}
            defaultVarietyID={selectedVarietyID}
            setProductID={setSelectedProductID}
            setVarietyID={setSelectedVarietyID}
            required={!selectedProductID}
          />
        </SearchBlockWithTitle>

        {selectedProductID && sizeList ? (
          <SearchBlockWithTitle title={['גודל']}>
            <SearchSize
              list={sizeList}
              defaultID={selectedSize}
              setSizeID={setSelectedSize}
            />
          </SearchBlockWithTitle>
        ) : ""}

        <SearchBlockWithTitle title={['מגדל']}>
          <SearchGrower
            list={growerList}
            defaultID={selectedGrowerID}
            setGrowerID={setSelectedGrowerID}
            required={!selectedGrowerID}
          />
        </SearchBlockWithTitle>

        <SearchBlockWithTitle title={['אריזה']}>
          <SearchPackage
            list={packageList}
            defaultID={selectedPackageID}
            setPackageID={setSelectedPackageID}
          />
        </SearchBlockWithTitle>
      </BodyWrapper>

      <ButtonWrapper>
        <ControlButton
          lable="ביטול"
          handleClick={onClose}
        />
        <ControlButton
          lable="הוסף"
          handleClick={handleAdd}
          disabled={!isFormValid()}
        />
      </ButtonWrapper>
    </ModalWrapper>
  )
}

export default AddProductModal

const ModalWrapper = styled.div`
  padding: 1em;
  display: flex;
  height: 100%; 
  flex-direction: column;
  justify-content: space-between;

`
// Body wrapper
const BodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
   gap: 0.5em;
`

const ButtonWrapper = styled.div`
  display: flex;
  gap: 0.5em;
  justify-content: flex-end;
` 